const setToken = (token = '') => sessionStorage.setItem('token', token);

export {
    setToken
};